export const IS_MOCK_SERVER_ENABLED = import.meta.env.VITE_MOCK_SERVER_ENABLED === "true"

export const MOCK_SERVER_BASE_API_URL = import.meta.env.VITE_MOCK_SERVER_BASE_API_URL as
  | string
  | undefined
